import { enumToOptions } from '@app/shared/helpers';
import { BasisOfHurdle } from '@app/shared/models/contracts/enums/shared-enums';
import { l, translationKeys } from '@locale/setupI18n';

export const getBasisOfHurdleOptions = () =>
  enumToOptions(BasisOfHurdle, undefined, true).map((o) => ({
    viewValue: l(o.viewValue as translationKeys),
    value: o.value,
  }));
